<!--
 * @Author: lwk liwkcool@163.com
 * @Date: 2025-03-12 16:11:34
 * @LastEditors: lwk liwkcool@163.com
 * @LastEditTime: 2025-03-18 16:11:45
 * @FilePath: \management-side\src\views\customPackage\components\designatedAccount.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="container">
        <el-popover :disabled="isDisabled" placement="top"  @show="handleShow" title="" popper-class="cust-popper" width="500" trigger="click"
            v-model="visible">
            <div v-loading="loading">
            <div class="header">
                <div>适用账号</div>
                <div @click="handleClear" class="clear">清除</div>
            </div>
            <el-input v-model="search"  @input="handleSearch" prefix-icon="el-icon-search"  placeholder="" size="small" clearable ></el-input>
            <div @click="handleCheckAll" class="all">全选</div>
            <el-checkbox-group v-if="sortedOptions.length"  class="cust-checkbox" v-model="employee">
                <el-checkbox v-for="item in sortedOptions" :key="item.id" :label="item.value">{{ item.label }}</el-checkbox>
            </el-checkbox-group>
            <div class="no-data" v-else>
                暂无数据
            </div>            
            <div class="footer">
                <el-button type="primary" size="small" @click="handleConfirm">确定</el-button>
                <el-button size="small" @click="visible = false">取消</el-button>
            </div>
        </div>
        
            <el-select :disabled="isDisabled" @change="handleChange" :popper-append-to-body="false" multiple  class="custom-select" slot="reference" v-model="person"   placeholder="请选择"  >
                <el-option v-for="item in options" 
                    :key="item.id"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
        </el-popover>
    </div>

</template>

<script>
export default {
    data() {
        return {
            visible: false,
            person: [],
            employee: [],
            search: '',
            options: [],
            filterOptions: [],
            loading: false
        };
    },
    props: {
        value: {
            type: Array,
            default: () => []
        },
        mangerPhonesAarry: {
            type: Array,
            default: () => []
        },
        isDisabled: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        value: {
            handler(val) {
                console.log(`val.map(Number)`, val.map(Number));
                this.person = JSON.parse(JSON.stringify(val));
            },
            immediate: true
        },
        mangerPhonesAarry: {
            handler(val) {
                this.options = val.map(item => {
                    return {
                        nickname: item.user.profile.nickname,
                        label: item.user.mobile,
                        value: item.user.userId,
                        id: item.id
                    }
                });
                this.filterOptions = val.map(item => {
                    return {
                        label: item.user.mobile,
                        value: item.user.userId,
                        id: item.id,
                        nickname: item.user.profile.nickname,
                    }
                });
            },
            immediate: true
        }
    },
    computed: {
        sortedOptions() {
        // 先复制一份数组避免修改原数组
        return [...this.filterOptions].sort((a, b) => {
                // 只在初始化时根据选中状态排序
                const aChecked = this.person.includes(a.value);
                const bChecked = this.person.includes(b.value);
                if (aChecked && !bChecked) return -1;
                if (!aChecked && bChecked) return 1;
                return 0;
            });
        },
    },
    methods: {
        handleSearch() {
            if(!this.search){
                this.filterOptions = this.options;
            }else{
                this.filterOptions = this.options.filter(item => item.label.includes(this.search));
            }
        },
        handleConfirm() {
            this.visible = false;
            // 更新person时会触发重新排序
            this.person = this.employee;
            this.$emit('input', this.employee?this.employee:[]);
        },
        handleChange(val) {
            this.employee = val;
            this.$emit('input', this.employee?this.employee:[]);
        },
        handleClear() {
            this.employee = [];
        },
        handleCheckAll() {
            if(!this.mangerPhonesAarry.length) return;   // 没有数据时不执行
            this.employee = this.filterOptions.map(item => item.value);
        },
        handleShow() {
            this.employee = this.person;
        }
    }
}
</script>

<style lang="scss">
.cust-popper {
    z-index: 9999 !important;
}
</style>
<style lang="scss" scoped>
.container {
    position: relative;
    width: 100%;

}

.header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
}
.no-data{
    text-align: center;
}
.clear {
    color: #409EFF;
    cursor: pointer;
}
.all{
    margin-bottom: 15px;
    margin-top: 15px;
    width: 60px;
    padding: 5px;
    text-align: center;
    border-radius: 20px;
    border: 1px solid #cccccc;
    cursor: pointer;
}
::v-deep .el-checkbox {
    display: block !important;
    margin-bottom: 15px;
}
.custom-select {
  ::v-deep .el-select-dropdown {
    display: none !important;
  }
}
.footer{
    text-align: right;
}
.cust-checkbox{
    max-height: 300px;
    overflow-y: auto;
    margin-bottom: 20px;
    // overflow-x: hidden;
    // padding-right: 10px;
}
</style>